/*用户 */
import { $http, buildHeaders } from "./index";

//获取列表
export const admin_page = (params) => {
  return $http.get("/admin/Admin/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const admin_detail = (id) => {
  return $http.get("/admin/Admin/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const admin_add = (data) => {
  return $http.post("/admin/Admin/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const admin_edit = (data) => {
  return $http.post("/admin/Admin/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const admin_delete = (id) => {
  return $http.post(
    "/admin/Admin/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//修改状态
export const admin_updateStatus = (data) => {
  return $http.post("/admin/Admin/updateStatus", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//重置密码
export const admin_resetPassword = (data) => {
  return $http.post("/admin/Admin/resetPassword", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};
